// extracted by mini-css-extract-plugin
export default {"container":"_5LEvw___RawToggle-module__container","input":"jYEMb___RawToggle-module__input","label":"_6P7V8___RawToggle-module__label","large":"Zltdb___RawToggle-module__large"};